import moment from 'moment'
import numeral from 'numeral'

const getOrganizationSettings = () => {
    return JSON.parse(localStorage.getItem('organizationSettings'))
}

const decode_bs64 = ( str ) =>{
    return decodeURIComponent(escape(window.atob( str )))
}

const encode_bs64 = ( value ) => {
    return window.btoa(unescape(encodeURIComponent(value)))
}

const formatPrice =(value, type) =>{
    const settings = getOrganizationSettings()
    if (type === 'currency'){
        const formatter = new Intl.NumberFormat(settings.locale, {
        style: 'currency',
        currency: settings.currency,
        minimumFractionDigits: settings.minimumFractionDigits,
        })
        return formatter.format(value)
    }else{
        return new Intl.NumberFormat(settings.locale, {
        }).format(value)
    }
  }
  
const formatNotification = (payload) => {
    const temp = []
    let cursor = null
    for(let item of payload){
        const { node } = item
        const extraData = JSON.parse(node.extraData)
        const object = {
            id: node.id,
            title: extraData.context.message.title,
            subtitle: extraData.context.message.subtitle,
            text: extraData.context.message.text,
            created: moment(node.createDate).format('LLL'),
            recipient: node.recipient.id,
            products: extraData.context.message.products,
            read: node.isRead
        }
        temp.push(object)
        cursor = item.cursor
    }
    return {
        data: temp,
        lastCursor: cursor
    }
}

const formatDate = (date, time = false)  => {
    const newDate = new Date(date);
    let options = {}
    if(time){
        options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZone: "America/Bogota",
        }
    }else{
        options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            timeZone: "America/Bogota",
        };
    }
   
    return new Intl.DateTimeFormat("es-Co", options).format(newDate);
  }

const formatDateShort = (date, time = false) => {
    const newDate = new Date(date)
    let options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: "America/Bogota"
    }
    if(time){
        options = {
            ...options,
            hour: "numeric",
            minute: "numeric"
        }
    }
    return new Intl.DateTimeFormat("es-CO", options).format(newDate)
}

const customDateTimeline = ( date ) => {
    const newDate = new Date(date)
    const options = {
        month: 'short',
        day: 'numeric'
    }
    return new Intl.DateTimeFormat('es-CO', options).format(newDate)
}

function formatCurrency(value){
    const regex = /^[0-9,]+$/
    if (!regex.test(value)) {
        return value.substring(0, value.length - 1)
    }else{
        const newValue = numeral(value).format('0,0').replaceAll('.', ',')
        return newValue
    }

}

function generate_new_date(date, start = true){
    const hour = start ? '00': '23'
    const minutes = start ? '00': '59'
    const _date = `${date}T${hour}:${minutes}:00`
    return _date
}

export {
    decode_bs64,
    encode_bs64,
    formatPrice,
    formatNotification,
    formatDate,
    formatCurrency,
    formatDateShort,
    generate_new_date,
    customDateTimeline
}